import { ButtonWithTooltip } from "Components/button";
import classNames from "classnames";
import React, { useCallback, useRef, useState } from "react";
import { TIMELINE_RANGE_SELECTOR_MODE } from "../constants";
import TimelineRangeSelector from "../timelineRangeSelector";
import locale from "./presentation.locale";
import styles from "./presentation.module.css";
const SIZES = {
    BUTTON_SIZE: 16
};
export default function Presentation(props) {
    const rangeSelectorRef = useRef(null);
    const [inPlayProgress, setInPlayProgress] = useState(false);
    const [presentationState, setPresentationState] = useState("stop");
    const handlePlay = useCallback(() => {
        var _a;
        (_a = rangeSelectorRef.current) === null || _a === void 0 ? void 0 : _a.play();
    }, []);
    const handlePause = useCallback(() => {
        var _a;
        (_a = rangeSelectorRef.current) === null || _a === void 0 ? void 0 : _a.pause();
    }, []);
    const handleStop = useCallback(() => {
        var _a;
        (_a = rangeSelectorRef.current) === null || _a === void 0 ? void 0 : _a.stop();
    }, []);
    const handleSetInterval = useCallback((interval) => {
        props.onSetInterval && props.onSetInterval(interval);
    }, [props.onSetInterval]);
    const notReadyForPlay = !props.data || !props.data.length;
    return (React.createElement("div", { className: classNames(styles.container, "unselectable") },
        React.createElement("div", { className: styles.toolbar },
            presentationState !== "stop" && (React.createElement(ButtonWithTooltip, { wrapperClassName: "line-height-1", className: "no-border no-default-colors", width: SIZES.BUTTON_SIZE, height: SIZES.BUTTON_SIZE, onClick: handleStop, disabled: notReadyForPlay, popoverContent: locale.STOP },
                React.createElement("i", { className: classNames("icon-presentation-stop font-h6 presentation-icon-bg") }))),
            presentationState === "play" && (React.createElement(ButtonWithTooltip, { wrapperClassName: "line-height-1 ml-0_75 mr-0_5", className: "no-border no-default-colors", width: SIZES.BUTTON_SIZE + 2, height: SIZES.BUTTON_SIZE + 2, onClick: handlePause, disabled: notReadyForPlay, popoverContent: locale.PAUSE },
                React.createElement("i", { className: classNames("icon-presentation-pause font-h6 presentation-icon-bg") }))),
            presentationState !== "play" && (React.createElement(ButtonWithTooltip, { wrapperClassName: "line-height-1 ml-0_75 mr-0_5", className: "no-border no-default-colors", width: SIZES.BUTTON_SIZE + 2, height: SIZES.BUTTON_SIZE + 2, onClick: handlePlay, disabled: notReadyForPlay, popoverContent: locale.PLAY },
                React.createElement("i", { className: classNames("icon-presentation-play font-h6 presentation-icon-bg") })))),
        React.createElement(TimelineRangeSelector, { mode: TIMELINE_RANGE_SELECTOR_MODE.PRESENTATION, maxTicksCount: props.maxTicksCount, data: props.data, interval: props.interval, inPlayProgress: inPlayProgress, presentationState: presentationState, onSetInterval: handleSetInterval, onSetInPlayProgress: setInPlayProgress, onSetPresentationState: setPresentationState, rangeSelectorRef: rangeSelectorRef })));
}
Presentation.defaultProps = {
    maxTicksCount: 60
};
